import React from "react";
import { useMandatorContext } from "@bn/theming";

export const MandatorMetaSync = () => {
  const { mandatorSlug, config } = useMandatorContext();
  const base = import.meta.env.BASE_URL.endsWith("/")
    ? import.meta.env.BASE_URL
    : `${import.meta.env.BASE_URL}/`;

  if (import.meta.env.VITE_APP_ENVIRONMENT !== "development") {
    return null;
  }

  return (
    <>
      <title>{config?.name}</title>
      <link
        rel="icon"
        type="image/svg+xml"
        href={`${base}favicon-${mandatorSlug}.svg`}
      />
      <link rel="manifest" href={`${base}manifest-${mandatorSlug}.json`} />
    </>
  );
};
